/**
 * @param {Number} delay
 * @param {Function} callback
 * @description 延时执行
 */
export const delayDev = (delay, callback) => {
  let _callback,
    _delay
  if (Object.prototype.toString.call(delay) === 'object Function') {
    _callback = delay
    _delay = 200
  } else {
    _callback = callback || function () {}
    _delay = delay
  }
  let timer = setTimeout(() => {
    _callback()
    clearTimeout(timer)
    timer = null
  }, _delay)
}

/**
 * @param {Object} obj
 */
export const objLen = (obj) => {
  return Object.keys(obj).length
}

/**
 * @param {Array} arr
 * @description 利用JSON来做深度复制
 */
export const clone = (arr) => {
  let str = JSON.stringify(arr)
  return JSON.parse(str)
}

/**
 * @param {Object} obj
 * @description 对象的复制
 * */
export const objCopy = (obj) => {
  let newObj = {}
  for (let prop in obj) {
    newObj[prop] = obj[prop]
  }
  return newObj
}

/**
 * @param {Object} target 目标对象
 * @param {Object} object 被合并对象
 * @description 对象合并
 */
export const combineObject = (target, object) => {
  return Object.assign(target, object)
}

/**
 * @param {Array} arr
 * @description 对象数组的深度复制
 */
export const deepCopy = (arr) => {
  let newArr = []
  for (let i = 0, len = arr.length; i < len; i++) {
    if (Object.prototype.toString.call(arr[i]) === '[object Object]') {
      newArr.push(objCopy(arr[i]))
    } else {
      newArr.push(arr[i])
    }
  }
  return newArr
}

/**
 * @description 本地连接search部分字符串转化为对象
 */
export const urlSearchToObject = () => {
  let obj = {};
  let str = location.search.substr(1);
  let arr = str.split('&');
  for (let i = 0, len = arr.length; i < len; i++) {
    let items = arr[i].split('=');
    obj[items[0]] = decodeURI(items[1]);
  }
  return obj;
}

/**
 * @description 传参
 */
export const searchToObject = search => {
  let obj = {};
  let str = search.substr(1);
  let arr = str.split('&');
  for (let i = 0, len = arr.length; i < len; i++) {
    let items = arr[i].split('=');
    obj[items[0]] = decodeURI(items[1]);
  }
  return obj;
}

/**
 * @param {String} str
 * @description 判断字符串中文字符串
 */
export const isChinese = (str) => {
  let pattern = /^[\u4E00-\u9FA5]+$/;
  return pattern.test(str);
}

/**
 * @param {String} str
 * @description 判断字符串英文字符串
 */
export const isLetter = (str) => {
  let pattern = /^[a-zA-Z]{1,16}$/g
  return pattern.test(str)
}

/**
 * @param {String} tel
 * @description 判断字符串英文字符串
 */
export const checkTel = (tel) => {
  let reg = /^(1[0-9]{10})$/
  return reg.test(tel)
}

export const checkMail = (mail) => {
  //var reyx = /^([a-zA-Z0-9_-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
  var reyx = /^\w+([-+.]\w+)*@\w+([-.]\w+)*\.\w+([-.]\w+)*$/;
  if (mail == "" || reyx.test(mail) == false) {
    return false;
  }
  return true;
}

export const checkPassport = (text) => {
  var reg = /^[A-Z]{1}[A-Z0-9]{1}[0-9]{7}$/
  return reg.test(text)
}

/**
 * @param {Number} money
 * @description 返回新字符串,格式1,200.00
 */
export const convert = money => {
  let s = money
  s += ''
  if (s.indexOf('.') === -1) s += '.0'
  if (/\.\d$/.test(s)) s += '0'
  while (/\d{4}(\.|,)/.test(s))
    s = s.replace(/(\d)(\d{3}(\.|,))/, '$1,$2')
  return s;
}
/**
 * @param {Number} num
 * @description 返回新字符串,格式1,200
 */
export const thousands = num => {
  return num.toLocaleString()
}
/**
 * @param {String} str
 * @description 手机号隐藏中间四位数 157****0417
 */
export const hideTel = str => {
  let _str = typeof str === 'string' ? str : `${str}`
  let reg = /^(\d{3})\d{4}(\d{4})$/
  return _str.replace(reg, '$1****$2')
}

/**
 * @param {String} string 源字符串
 * @param {Number} num 截取字符数量
 * @description 截取字符
 */
export const interceptChar = (string, num) => {
  if (string.length > num) return string.substr(0, num) + '...'
  return string
}

/**
 * @description 数字转换为中文
 * @return string
 */
export function numberToChinese(num) {
  const numberArr = ['零', '一', '二', '三', '四', '五', '六', '七', '八', '九']
  const unitArr = ['', '十', '百', '千', '万', '十', '百', '千', '亿', '十', '百', '千', '万', '十', '百', '千', '亿']
  if (!num || isNaN(num)) {
    return '零'
  }
  let targetArr = num.toString().split('')
  targetArr.reverse() //翻转
  let result = ''
  for (let i = 0; i < targetArr.length; i++) {
    result = unitArr[i] + result
    let numberArr_index = targetArr[i]
    result = numberArr[numberArr_index] + result
  }
  //将【零千、零百】换成【零】 【十零】换成【十】
  result = result.replace(/零(千|百|十)/g, '零').replace(/十零/g, '十')
  //合并中间多个零为一个零
  result = result.replace(/零+/g, '零')
  //将【零亿】换成【亿】【零万】换成【万】
  result = result.replace(/零亿/g, '亿').replace(/零万/g, '万')
  //将【亿万】换成【亿】
  result = result.replace(/亿万/g, '亿')
  //移除末尾的零
  result = result.replace(/零+$/, '')
  //将【零一十】换成【零十】
  //result = result.replace(/零一十/g, '零十');//貌似正规读法是零一十
  //将【一十】换成【十】
  result = result.replace(/^一十/g, '十')
  return result
}

export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}


export function isMobile() {
  if (typeof window == 'undefined') return false

  var v = navigator.userAgent.toLowerCase()
  var result = v.match(/(ios|iphone|ipod|ipad|mobile|android|symbianos|ucweb|mqqbrowser|iemobile|webos|windows phone|windows mobile|opera mini|opera mobl|nexus|series|nokia|blackberry|meego|playbook|fennec|tablet|wechat)/) ? !0 : !1
  return result
}

export function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min) + min);
}


export function gioTracking(type, eventName, eventObject) {
  // console.log(type, eventName, eventObject ? JSON.stringify(eventObject): "");
  if (window && window.gio) {
    try {
      if (eventObject) {
        window.gio(type, eventName, eventObject);
      } else {
        window.gio(type, eventName);
      }
    } catch (e) {
      console.error(e);
    }
  }
}

export function gioRecord(type, eventName, eventObject) {
	// console.log(type, eventName, eventObject ? JSON.stringify(eventObject): "");
	if (window && window.gio) {
		try {
			if (eventObject) {
				window.gio(type, eventName, eventObject);
			} else {
				window.gio(type, eventName);
			}
		} catch (e) {
			console.error(e);
		}
	}
}

export function gioAdsTracking(eventObject) {
  const event = {
    "adsType": eventObject.adsType || "nil",
    "bnOrder": eventObject.bnOrder || "nil",
    "lsCatOrder": eventObject.lsCatOrder || "nil",
    "lsItmOrder": eventObject.lsItmOrder || "nil",
    "chOrder": eventObject.chOrder || "nil",
    "spCode": eventObject.spCode || "nil",
    "spVideo": eventObject.spVideo || "nil",
    "spCat": eventObject.spCat || "nil",
    "rcmOrder": eventObject.rcmOrder || "nil",
    "chDes": eventObject.chDes || "nil",
    "chDesVideo": eventObject.chDesVideo || "nil",
    "topList": eventObject.topList || "nil",
    "desUrl": eventObject.desUrl || "nil"
  }
  gioTracking('track', 'evt_AdsClicked', event);
}

export function isHkSpecialCruise(shipCode, sailDate, departureCode) {
  let date = Date.parse(sailDate);
  let isHKSpecialCruise = false;
  if(date >= Date.parse("2021-10-05") && date < Date.parse("2022-01-31")){
    isHKSpecialCruise = true;
  }
  return shipCode === "SC" && isHKSpecialCruise && departureCode === "HKG";
}

export function differDays(startDate) {
  let now = new Date().getTime() / 1000;
  let endTime = new Date(startDate).getTime() / 1000 - now;
  let timeDays = endTime/60/60/24;        //相差天数
  return timeDays;
}

/**
 * 根据日期字符串，返回时间戳
 * @param dateStr 日期字符串
 * @returns {string}
 */
export function dateStrToTimeTamp(dateStr) {
  let timeTamp = "";
  if(dateStr) {
    dateStr = dateStr.replace(/-/g, '/');
    timeTamp = new Date(dateStr).getTime();
  }
  return timeTamp;
}
